/* SAEGE — Shop the look (collection grid card + bottom sheet / modal) */
(function () {
  if (window.SaegeShopTheLook) return;
  window.SaegeShopTheLook = true;

  var openId = null;
  var lastTrigger = null;

  // Modals render inside the product grid; move them to <body> so position:fixed and
  // z-index behave, and so AJAX filtering can replace the grid without breaking them.
  function relocateModals() {
    document.querySelectorAll('.saege-stl-modal').forEach(function (m) {
      if (m.parentElement === document.body) return;
      var existing = document.body.querySelector('#' + m.id);
      if (existing && existing !== m) existing.remove();
      document.body.appendChild(m);
    });
  }

  function open(id, trigger) {
    relocateModals();
    var m = document.getElementById(id);
    if (!m) return;
    if (openId && openId !== id) close(true);
    lastTrigger = trigger || null;
    m.hidden = false;
    void m.offsetWidth; // force a style flush so the transition runs
    m.classList.add('is-open');
    document.documentElement.classList.add('saege-stl-lock');
    openId = id;
    var c = m.querySelector('.saege-stl-modal__close');
    if (c) setTimeout(function () { c.focus({ preventScroll: true }); }, 50);
  }

  function close(immediate) {
    if (!openId) return;
    var m = document.getElementById(openId);
    openId = null;
    document.documentElement.classList.remove('saege-stl-lock');
    if (!m) return;
    m.classList.remove('is-open');
    if (immediate) { m.hidden = true; }
    else { setTimeout(function () { m.hidden = true; }, 260); }
    if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus({ preventScroll: true });
    lastTrigger = null;
  }

  var TICK = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M3 8.5l3.2 3.2L13 5"/></svg>';

  function addToCart(btn) {
    if (btn.disabled) return;
    var id = btn.getAttribute('data-saege-stl-add');
    var html = btn.innerHTML;
    btn.disabled = true;
    btn.classList.add('is-busy');
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () {
        btn.classList.remove('is-busy');
        btn.classList.add('saege-stl-item__btn--added');
        btn.innerHTML = TICK;
        document.dispatchEvent(new CustomEvent('theme:cartchanged'));
        close();
        setTimeout(function () {
          document.dispatchEvent(new CustomEvent('theme:open-cart-drawer'));
        }, 250);
        setTimeout(function () {
          btn.disabled = false;
          btn.classList.remove('saege-stl-item__btn--added');
          btn.innerHTML = html;
        }, 1500);
      })
      .catch(function () {
        btn.disabled = false;
        btn.classList.remove('is-busy');
        btn.setAttribute('title', 'Could not add — try again');
      });
  }

  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-saege-stl-open]');
    if (o) { e.preventDefault(); open(o.getAttribute('data-saege-stl-open'), o); return; }
    if (e.target.closest('[data-saege-stl-close]')) { e.preventDefault(); close(); return; }
    var a = e.target.closest('[data-saege-stl-add]');
    if (a) { e.preventDefault(); addToCart(a); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openId) close();
  });

  // Swipe down on the sheet header to dismiss (mobile)
  var startY = null;
  document.addEventListener('touchstart', function (e) {
    startY = e.target.closest('.saege-stl-modal__head') ? e.touches[0].clientY : null;
  }, { passive: true });
  document.addEventListener('touchend', function (e) {
    if (startY !== null && e.changedTouches[0].clientY - startY > 60) close();
    startY = null;
  }, { passive: true });

  relocateModals();
  document.addEventListener('DOMContentLoaded', relocateModals);
  document.addEventListener('shopify:section:load', relocateModals);
  // Theme editor: open the sheet when the merchant selects the block
  document.addEventListener('shopify:block:select', function (e) {
    var card = e.target && e.target.querySelector && e.target.querySelector('[data-saege-stl-open]');
    if (card) open(card.getAttribute('data-saege-stl-open'), card);
  });
  document.addEventListener('shopify:block:deselect', function () { close(); });
})();
